export default __webpack_public_path__ + "static/media/bishop.df5526d9.png";